<ul class="list-unstyled ms-3">
    <li *ngFor="let category of displayCategories" class="mt-1">
        <ng-container *ngIf="category.children.length > 0; else leafItem">
            <div class="d-flex justify-content-between align-items-center clickable" (click)="select(category)">
                <span>{{ category.name }}</span>
                <span class="bi bi-chevron-right"></span>
            </div>
        </ng-container>
        <ng-template #leafItem>
            <ng-container *ngIf="emitLeaves; else menuToggle">
                <div class="clickable" (click)="select(category)">{{ category.name }}</div>
            </ng-container>
            <ng-template #menuToggle>
                <ion-menu-toggle>
                    <a routerLink="/search" [queryParams]="{ category: category.id }">{{ category.name }}</a>
                </ion-menu-toggle>
            </ng-template>
        </ng-template>
    </li>
</ul>
